import lodash from "lodash";
import { createColumnInput } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { createButtonCreate } from "../../../../utils/button";
import { onClickDeleteAllClient } from "../../../../utils/form";
import { onIFrameClickSelectAll } from "../../../../utils/iframe";
import { createLoading } from "../../../../utils/loading";
import { createManageDelete, createManageExportCsv, createPage } from "../../../../utils/page";
import { openModalList as openModalListUser } from "../mgt-tab/tab-4/tab4-data.logic";

export const { isLoading, setIsLoading } = createLoading();

export const createColumns = () => {
    const columns = [];
    columns.push(createColumnInput({ title: () => i18n.global.t("model.user.username"), dataIndex: "refUser.username", align: "center" }));
    columns.push(createColumnInput({ title: () => i18n.global.t("model.user.fullNameTh"), dataIndex: "refUser.fullNameTh", width: 200 }));
    return columns;
};

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey, user } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: items });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => !viewOnly,
            onClick: ({ rowSelection }) => {
                onClickDeleteAllClient({ rowSelection, useForm, items, key: itemsKey });
                data.page.page = 0;
            }
        }),
        createManageExportCsv({ menuContext })
    ];
    data.manageExtras = [];
    data.rowActions = [];

    if (!viewOnly) {
        data.manageExtras.push({
            render: () => ({
                ...createButtonCreate({
                    onClick: () =>
                        openModalListUser({
                            onIframeMounted: ({ refs, options }) =>
                                onIFrameClickSelectAll({
                                    refs,
                                    options,
                                    items,
                                    itemKey: "refUser.id",
                                    rowKey: "id",
                                    setKey: "refUser"
                                }),
                            companyId: user.id,
                            personType: user.refPersonType?.key
                        }),
                    options: {
                        text: i18n.global.t("model.user.modelName")
                    }
                })
            }),
            visible: () => true
        });
    }
};
